export default class GenesysVideoService {
  constructor({ host, accountId }) {
    this.host = host
    this.accountId = accountId
  }

  async getWebRTCToken(params, callback) {
    const url = `${this.host}/accounts/${this.accountId}/genesys-audio-webrtc-token`
    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    })
      .then((response) => response.json())
      .then(callback)
  }

  async createVideoRoom(name) {
    const url = `${this.host}/accounts/${this.accountId}/create-video-room`

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ roomName: name }),
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json()
      return data
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error)
      throw error
    }
  }

  async createVideoRoomToken(roomId) {
    const url = `${this.host}/accounts/${this.accountId}/create-video-room-token `

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ roomId: roomId }),
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json()
      return data
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error)
      throw error
    }
  }
}
